module.exports = __webpack_public_path__ + "static/media/feature-insights.7d874884.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-insights.png
// module id = 177
// module chunks = 0